// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1myHA","selected":"Chip_selected__OaXlV"};